import React, { Component } from 'react'

export class Box extends Component {
  render() {
    return <div>Box</div>
  }
}

export default Box
